// src/payment-filter/payment-filter-schema.ts
import { oz as oz8 } from "@vy/oz";

// src/payment-filter/payment-filter-schemas/payment-status-filter-schema.ts
import { oz } from "@vy/oz";
import { EnumFilterInputSchema } from "@vy/query-specifications-types";
import { PAYMENT_STATUSES } from "@vy/types";

// src/payment-filter/payment-filterable-fields.ts
var PAYMENT_FILTERABLE_FIELDS = Object.freeze({
  STATUS: "status",
  CUSTOMER_NAME: "customer.name",
  TRANSACTION_ID: "transactionId",
  AMOUNT: "amount",
  PAYMENT_DATE: "paymentDate",
  PAYMENT_METHOD: "paymentInfo.paymentMethod",
  CURRENCY: "currency"
});

// src/payment-filter/payment-filter-schemas/payment-status-filter-schema.ts
var PaymentStatusFieldPathSchema = oz.literal(PAYMENT_FILTERABLE_FIELDS.STATUS);
var PaymentStatusFilterSchema = EnumFilterInputSchema.extend({
  field: PaymentStatusFieldPathSchema,
  value: oz.union([oz.nativeEnum(PAYMENT_STATUSES), oz.array(oz.nativeEnum(PAYMENT_STATUSES))])
}).openapi("PaymentStatusFilter");

// src/payment-filter/payment-filter-schemas/payment-customer-name-filter-schema.ts
import { oz as oz2 } from "@vy/oz";
import { StringFilterInputSchema } from "@vy/query-specifications-types";
var PaymentCustomerNameFieldPathSchema = oz2.literal(PAYMENT_FILTERABLE_FIELDS.CUSTOMER_NAME);
var PaymentCustomerNameValueSchema = oz2.union([oz2.string(), oz2.array(oz2.string())]);
var PaymentCustomerNameFilterSchema = StringFilterInputSchema.extend({
  field: PaymentCustomerNameFieldPathSchema,
  value: PaymentCustomerNameValueSchema
}).openapi("PaymentCustomerNameFilter");

// src/payment-filter/payment-filter-schemas/payment-transaction-id-filter-schema.ts
import { oz as oz3 } from "@vy/oz";
import { NumberFilterInputSchema } from "@vy/query-specifications-types";
var PaymentTransactionIdFieldPathSchema = oz3.literal(PAYMENT_FILTERABLE_FIELDS.TRANSACTION_ID);
var PaymentTransactionIdValueSchema = oz3.union([oz3.number(), oz3.array(oz3.number())]);
var PaymentTransactionIdFilterSchema = NumberFilterInputSchema.extend({
  field: PaymentTransactionIdFieldPathSchema,
  value: PaymentTransactionIdValueSchema
}).openapi("PaymentTransactionIdFilter");

// src/payment-filter/payment-filter-schemas/payment-amount-filter-schema.ts
import { oz as oz4 } from "@vy/oz";
import { NumberFilterInputSchema as NumberFilterInputSchema2 } from "@vy/query-specifications-types";
var PaymentAmountFieldPathSchema = oz4.literal(PAYMENT_FILTERABLE_FIELDS.AMOUNT);
var PaymentAmountValueSchema = oz4.union([oz4.number(), oz4.array(oz4.number())]);
var PaymentAmountFilterSchema = NumberFilterInputSchema2.extend({
  field: PaymentAmountFieldPathSchema,
  value: PaymentAmountValueSchema
}).openapi("PaymentAmountFilter");

// src/payment-filter/payment-filter-schemas/payment-date-filter-schema.ts
import { oz as oz5 } from "@vy/oz";
import { DateFilterInputSchema } from "@vy/query-specifications-types";
var PaymentDateFieldPathSchema = oz5.literal(PAYMENT_FILTERABLE_FIELDS.PAYMENT_DATE);
var PaymentDateValueSchema = oz5.union([oz5.string().datetime(), oz5.array(oz5.string().datetime())]);
var PaymentDateFilterSchema = DateFilterInputSchema.extend({
  field: PaymentDateFieldPathSchema,
  value: PaymentDateValueSchema
}).openapi("PaymentDateFilter");

// src/payment-filter/payment-filter-schemas/payment-method-filter-schema.ts
import { oz as oz6 } from "@vy/oz";
import { StringFilterInputSchema as StringFilterInputSchema2 } from "@vy/query-specifications-types";
var PaymentMethodFieldPathSchema = oz6.literal(PAYMENT_FILTERABLE_FIELDS.PAYMENT_METHOD);
var PaymentMethodValueSchema = oz6.union([oz6.string(), oz6.array(oz6.string())]);
var PaymentMethodFilterSchema = StringFilterInputSchema2.extend({
  field: PaymentMethodFieldPathSchema,
  value: PaymentMethodValueSchema
}).openapi("PaymentMethodFilter");

// src/payment-filter/payment-filter-schemas/payment-currency-filter-schema.ts
import { oz as oz7 } from "@vy/oz";
import { EnumFilterInputSchema as EnumFilterInputSchema2 } from "@vy/query-specifications-types";
import { CURRENCIES } from "@vy/types";
var PaymentCurrencyFieldPathSchema = oz7.literal(PAYMENT_FILTERABLE_FIELDS.CURRENCY);
var PaymentCurrencyFilterSchema = EnumFilterInputSchema2.extend({
  field: PaymentCurrencyFieldPathSchema,
  value: oz7.union([oz7.nativeEnum(CURRENCIES), oz7.array(oz7.nativeEnum(CURRENCIES))])
}).openapi("PaymentCurrencyFilter");

// src/payment-filter/payment-filter-schema.ts
var PaymentFilterSchema = oz8.union([
  PaymentStatusFilterSchema,
  PaymentCustomerNameFilterSchema,
  PaymentTransactionIdFilterSchema,
  PaymentAmountFilterSchema,
  PaymentDateFilterSchema,
  PaymentMethodFilterSchema,
  PaymentCurrencyFilterSchema
]).openapi("PaymentFilter");

// src/payment-tolerance.ts
var PAYMENT_TOLERANCE = 0.1;
export {
  PAYMENT_FILTERABLE_FIELDS,
  PAYMENT_TOLERANCE,
  PaymentAmountFieldPathSchema,
  PaymentAmountFilterSchema,
  PaymentCurrencyFieldPathSchema,
  PaymentCurrencyFilterSchema,
  PaymentCustomerNameFieldPathSchema,
  PaymentCustomerNameFilterSchema,
  PaymentDateFieldPathSchema,
  PaymentDateFilterSchema,
  PaymentFilterSchema,
  PaymentMethodFieldPathSchema,
  PaymentMethodFilterSchema,
  PaymentStatusFieldPathSchema,
  PaymentStatusFilterSchema,
  PaymentTransactionIdFieldPathSchema,
  PaymentTransactionIdFilterSchema
};
